var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{directives:[{name:"resize",rawName:"v-resize",value:(_vm.onResize),expression:"onResize"}]},[(_vm.$store.state.splashScreen == true)?_c('SplashLoader'):_vm._e(),_c('router-view'),(_vm.$store.state.splashScreen == false)?_c('SpeedTest'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }